import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbTooltipModule, NgbCollapseModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';


import { UIModule } from '../shared/ui/ui.module';
import { EventService } from '../core/services/event.service';

import { LayoutComponent } from './layout.component';
import { MenuComponent } from './shared/menu/menu.component';
import { TopbarComponent } from './shared/topbar/topbar.component';
import { LeftsidebarComponent } from './shared/leftsidebar/leftsidebar.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { VerticalComponent } from './vertical/vertical.component';
import { SubmenueComponent } from './shared/submenue/submenue.component';
import { RightsidebarComponent } from './shared/rightsidebar/rightsidebar.component';
import { SharedModule } from '../shared/shared.module';
import { ToastsContainer } from './shared/toasts/toasts.component';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent, MenuComponent, TopbarComponent, RightsidebarComponent, LeftsidebarComponent, HorizontalComponent, VerticalComponent, SubmenueComponent, ToastsContainer],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbCollapseModule,
    NgbToastModule,
    UIModule,
    SharedModule
  ],
  exports: [TopbarComponent, MenuComponent, LeftsidebarComponent, ],
  providers: [EventService]
})
export class LayoutsModule { }
